import React from 'react';

import styles from '../ActivityCompactCard/ActivityCompactCard.scss';
import cls from 'classnames';
import { SkeletonItem } from '../Skeleton/Skeleton';

type Props = {
  className?: string;
};

const SkeletonCompact = ({ className }: Props) => {
  return (
    <div className={cls(styles.container, styles.isSkeleton, className)}>
      <div>
        <SkeletonItem width={108} height={20} className={styles.translatedSkeleton} />

        <div className={cls(styles.grid, styles.titlePriceRow)}>
          <SkeletonItem width={200} height={24} />
          <SkeletonItem width={48} height={24} />
        </div>

        <div className={styles.tags}>
          <SkeletonItem width={72} height={12} />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCompact;
